
import { Component, Inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgxHekaDesignLibModule } from 'ngx-heka-design-lib';

/**
 * Similar to other app's but intentionally not in library because of possible future styling adaptations.
 */
@Component({
  selector: 'app-websocket-action-dialog',
  imports: [NgxHekaDesignLibModule, MatButtonModule, MatDialogModule, TranslateModule],
  templateUrl: './websocket-action-dialog.component.html',
  standalone: true,
  styleUrl: './websocket-action-dialog.component.scss'
})
export class WebsocketActionDialogComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() buttonTitle: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; description: string; buttonTitle: string }
  ) {
    this.title = data?.title;
    this.description = data?.description;
    this.buttonTitle = data?.buttonTitle;
  }
}
